import jQuery from 'jquery';

jQuery(function ($) {
    'use strict';

    const $openers = $('.accordion .opener');

    $openers.closest('.accordion__item').addClass('closed');

    $openers.on('click', function (e) {
        e.preventDefault();
        const expanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', expanded === 'true' ? 'false' : 'true');
        $(this)
            .closest('.accordion__item')
            .find('.content')
            .prop('inert', expanded === 'true');
        $(this).closest('.accordion__item').toggleClass('closed');
    });
});
